// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('frontDoorPage', ['landingPage'])
  // The following code prevents angular from manipulating the URL. This is necessary
  // for pages with anchor links and do not need browser history manipulation.
  .config([
    '$provide',
    ($provide) =>
      $provide.decorator('$browser', [
        '$delegate',
        function ($delegate) {
          $delegate.onUrlChange = () => null;
          $delegate.url = () => '';
          return $delegate;
        },
      ]),
  ]);

$(document).ready(function () {
  $('.craft-download').click(function () {
    return $(document).trigger('track.inVisionPlugin.Download', {
      content: $(this).attr('data-nav'),
    });
  });

  // update ups search on specific front door pages
  const upsSearchParams = (() => {
    switch (document.location.pathname) {
      case '/creative-images':
        return {
          type: 'image',
          family: 'creative',
        };
      case '/editorial-images':
        return {
          type: 'image',
          family: 'editorial',
        };
      case '/footage':
        return {
          type: 'film',
          family: null,
        };
    }
  })();

  if (window.eventBus && upsSearchParams) {
    return eventBus.on('ups-header.search-loaded', (data) =>
      eventBus.trigger('ups-header.search-config', upsSearchParams)
    );
  }
});
